import React from 'react';
import { Dropdown } from 'react-bootstrap';
import i18n from "utils/I18n";

import './ActivityLogFilter.scss';

const ActivityLogFilterDropdown = ({ onClick, isChecked }) => (
  <Dropdown className="activity-log-filter">
    <Dropdown.Toggle
      variant="success"
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
      }}
    >
      <div className="activity-log-filter-button button-large">
        <div className="filter-gear">
          <img className="p2_color_image" alt="down" src="/action/gear.svg" />
        </div>
        <div className="dot-container">
          {isChecked ? <div className="dot" /> : null}
        </div>
        {i18n.t("Display")}
      </div>
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item>
        <div className="activity-log-filter-dropdown" onClick={onClick}>
          <div className="filter-check-box">
            {isChecked ? (
              <img
                className="p2_color_image"
                src="/action/mulitSelectChecked.png"
                srcSet="/action/mulitSelectChecked@2x.png 2x, /action/mulitSelectChecked@3x.png 3x"
              />
            ) : (
              <img
                className="p2_color_image"
                src="/action/mulitSelect.png"
                srcSet="/action/mulitSelect@2x.png 2x, /action/mulitSelect@3x.png 3x"
              />
            )}
          </div>
          <div className="filter-title">
            <label className="body-2">{i18n.t("show_non_rewarded_logs")}</label>
          </div>
        </div>
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
);

export default ActivityLogFilterDropdown;
